


























































































































import {
  checklistPostReq,
  genPostReq
} from "@/services/checklist.service";



export default  {
  props: ['cl_item'], 
  data() {
    return {
      step_view: 1,
      error_message: "", 
      alert_type: "error", 
      create_progress: false,
      inspect_id: "",  //checklist/testHannes_1567521767
      inspect_data: {}, 
      checklist_dialog: {},
      create_error: false, 
      cl_entry: {}
    }
  },
  watch: {

  },
  computed: {
    appLang: function() {
      return this.$store.state.lang
    },
  },
  mounted() {

  },
  destroyed() {
    //console.log("destroyed")
  },
  methods: {
    step2: function () {
      if (this.inspect_id && this.inspect_id.length > 10) {
        this.create_progress = true
        genPostReq('importjson', 'cdb-checklist', { "id" : this.inspect_id, "type" : "check" })
        .then(resp => {
          this.export_dialog = false
          if (resp.status == "success") {
            if (!resp.data.exists) {
              this.error_message = "Checkliste nicht vorhanden."
              this.create_error = true
              this.create_progress = false
            } else {
              this.inspect_data = resp.data
              this.create_progress = false
              this.step_view = 2

              if (this.inspect_data.checklist_entries > 0) {
                this.error_message = "Bereits "+this.inspect_data.checklist_entries+" Checkliste(n) mit dieser ID importiert."
                this.create_error = true
                this.alert_type = "info"
              }
            }
          }
        })
        .catch(e => {
          this.$store.dispatch("api_error", e);
        }); 
       
      }
    },
    step3: function () {
      this.create_error = false
      this.create_progress = true
        genPostReq('importjson', 'cdb-checklist', { "id" : this.inspect_id, "type" : "import" })
        .then(resp => {
          this.export_dialog = false
          if (resp.status == "success") {
            console.log(resp)
            if (!resp.data.exists) {
              this.error_message = this.$t('LABEL71')
              this.create_error = true
              this.create_progress = false
            } else {
              this.create_progress = false
              this.create_error = false
              this.$store.state.checklists = resp.data.list
              this.$emit("dialogClosed", { saved: true });
            }
          }
        })
        .catch(e => {
          this.$store.dispatch("api_error", e);
        }); 
    },
    closeDialog: function () {
      this.$emit("dialogClosed", true);
    },
    save: function () {
      this.create_error = false
      if (!this.cl_entry.version ) {
        this.create_error = true
      } else {
         this.create_progress = true
 
          checklistPostReq('couchdb-transferchecklist', { version: this.cl_entry.version, comment: this.cl_entry.comment, uid: this.cl_item.uid, rev: this.cl_entry._rev }) 
            .then(resp => {
              console.log(resp)
              this.$emit("dialogClosed", true);
            })
            .catch(e => {
              this.$store.dispatch("api_error", e);
          }); 

      }
    }
   
  }
}

